import Vue from "vue";
import App from "./App.vue";
import vuetify from './plugins/vuetify';

Vue.config.productionTip = false;

new Vue({
  vuetify,
  theme: { light: true },
  render: h => h(App)
}).$mount("#app");

